// extracted by mini-css-extract-plugin
export default {"subcategoriesRow":"m_bs","subcategoryColumn":"m_bt","articleLink":"m_bv","articleCoverImage":"m_bw","articleTitle":"m_bx"};